export default __webpack_public_path__ + "static/ring10-dca790587b4370226bf3a49fe3d78309.png";